import type { HexaColor } from '../status.type';

type Props = {
  size: number;
  color?: HexaColor;
};
export const TodoProgress = ({ size, color = '#95999f' }: Props) => (
  <svg fill="none" height={size} viewBox="0 0 14 14" width={size}>
    <circle
      cx="7"
      cy="7"
      fill="none"
      r="6"
      stroke={color}
      strokeDasharray="1.4 1.74"
      strokeDashoffset="0.65"
      strokeWidth="2"
    />
    <circle
      cx="7"
      cy="7"
      fill="none"
      r="2"
      stroke={color}
      strokeDasharray="0 100"
      strokeDashoffset="0"
      strokeWidth="4"
      transform="rotate(-90 7 7)"
    />
  </svg>
);
